<template>
  <EndorsementContract :isQuotation="true" />
</template>

<script>
import EndorsementContract from '../../components/contracts/EndorsementContract.vue';

export default {
  components: {
    EndorsementContract,
  },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.table-striped-col td:nth-child(2n) {
  background-color: #edf4fb;
}

.table-striped-col td:nth-child(2n + 1) {
  background-color: #ffffff;
}

.font-small {
  font-size: 0.8rem;
}

.font-xsmall {
  font-size: 0.7rem;
}

.uppercase {
  text-transform: uppercase;
}

.table-pt {
  padding-top: 8px !important;
}

.title {
  background-color: #2b50bb !important;
  color: white;
}
</style>
